/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Content } from 'antd/lib/layout/layout'
import {
  Popconfirm,
  Button,
  Layout,
  Space,
  Table,
  Menu,
  Row,
  Col,
  Dropdown
} from 'antd'
import {
  DeleteOutlined,
  PlusCircleOutlined,
  DownloadOutlined,
  EyeOutlined
} from '@ant-design/icons'

import { DefaultLayout } from 'src/layouts/default'
import { Gap } from 'src/components/atoms/Gap'
import { Header } from 'src/components/molecules/Header'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { CSVLink } from 'react-csv'
import './style/style.css'

export const _Coupon = ({
  token,
  dispatch,
  data,
  dataMaster,
  dataDownload,
  loading,
  meta
}) => {
  const downloadCsvRef = useRef()
  const navigation = useNavigate()
  const [filename, setFileName] = useState('')

  const [value, setValue] = useState('')
  const text = 'Are you sure to delete this task?'

  const exportDropdownOverlay = ({ couponId, downloadCsv }) => {
    return (
      <Menu>
        <Menu.Item
          key={1}
          onClick={() =>
            downloadCsv(couponId, 'customer-files', 'Facebook_Customer_Files')}
        >
          <Row>
            <Col span={24} className='download-data-coupon'>
              Facebook Customer Files
            </Col>
          </Row>
        </Menu.Item>
        <Menu.Item
          key={2}
          onClick={() =>
            downloadCsv(couponId, 'ltv', 'Facebook_Customer_Files_with_LTV')}
        >
          <Row>
            <Col span={24} className='download-data-coupon'>
              Facebook Customer Files with LTV
            </Col>
          </Row>
        </Menu.Item>
        <Menu.Item
          key={3}
          onClick={() =>
            downloadCsv(
              couponId,
              'offline-conversion',
              'Facebook_Offline_Conversion'
            )}
        >
          <Row>
            <Col span={24} className='download-data-coupon'>
              Facebook Offline Conversion
            </Col>
          </Row>
        </Menu.Item>
        <Menu.Item
          key={4}
          onClick={() => downloadCsv(couponId, 'track', 'Coupon_Claimers')}
        >
          <Row>
            <Col span={24} className='download-data-coupon'>
              Coupon Claimers
            </Col>
          </Row>
        </Menu.Item>
      </Menu>
    )
  }

  const viewDropdownOverlay = (items) => (
    <Menu>
      <Menu.Item
        key={1}
        onClick={() => onHandlePreview({ items, type: 'all' })}
      >
        <Row>
          <Space className='download-data-coupon'>All data</Space>
        </Row>
      </Menu.Item>
      <Menu.Item
        key={2}
        onClick={() => onHandlePreview({ items, type: 'grouped-by-phone' })}
      >
        <Row>
          <Col span={24} className='download-data-coupon'>
            Grouped by phone
          </Col>
        </Row>
      </Menu.Item>
    </Menu>
  )

  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'product',
      align: 'center',
      render: (item, obj) => <a>{item.name}</a>
    },
    {
      title: 'Code Coupon',
      dataIndex: 'coupon',
      align: 'center'
    },
    {
      title: 'Discount',
      dataIndex: 'discount',
      align: 'center',
      render: (item) => {
        return (
          <div>
            {item > 100
              ? `Rp${Intl.NumberFormat('id').format(item)}`
              : `${item}%`}
          </div>
        )
      }
    },
    {
      title: 'Fix Price',
      dataIndex: 'fixprice',
      align: 'center',
      render: (item, obj) => {
        return (
          <div className='flex'>
            Rp
            {Intl.NumberFormat('id').format(
              obj.product?.price - obj.discountCalculated?.priceDiscounted
            )}
            <span
              className='ml-2'
              style={{
                textDecoration: 'line-through',
                color: '#1486C9',
                fontSize: 10
              }}
            >
              Rp{Intl.NumberFormat('id').format(obj.product?.price)}
            </span>
          </div>
        )
      }
    },
    {
      title: 'Periode',
      dataIndex: 'periode',
      align: 'center',
      render: (txt, obj) =>
        moment(obj.startDate).format('L') +
        ' - ' +
        moment(obj.endDate).format('L')
    },
    {
      title: 'Action',
      dataIndex: 'action',
      width: 300,
      align: 'center',
      render: (txt, obj) => {
        return (
          <Space>
            <Dropdown overlay={viewDropdownOverlay(obj)}>
              <Button className='button-detail' size='small'>
                <Space>
                  <EyeOutlined />
                  <Space>View</Space>
                </Space>
              </Button>
            </Dropdown>
            <Popconfirm
              placement='topLeft'
              title={text}
              onConfirm={() => onHandleDelete(obj)}
              okText='Yes'
              cancelText='No'
            >
              <Button size='small' className='button-delete'>
                <DeleteOutlined />
              </Button>
            </Popconfirm>
            <Dropdown
              overlay={exportDropdownOverlay({
                couponId: obj.id,
                downloadCsv
              })}
            >
              <Button size='small' className='button-upload'>
                <DownloadOutlined />
                Export Data
              </Button>
            </Dropdown>
          </Space>
        )
      }
    }
  ]

  useEffect(() => {
    dispatch({
      type: 'coupon/get_coupon',
      payload: { token }
    })
    dispatch({
      type: 'product_master/get_product_master',
      payload: { token }
    })
  }, [])

  useEffect(() => {
    if (dataDownload) {
      downloadCsvRef.current?.link?.click()
    }
  }, [dataDownload])

  const onHandleSearch = () => {
    dispatch({
      type: 'coupon/get_coupon',
      payload: { token, params: { coupon: value } }
    })
  }

  const onHandleCreateCampaign = () => {
    navigation('/dashboard/coupon/create', { state: token })
  }

  const onHandleDelete = (items) => {
    dispatch({
      type: 'coupon/delete_coupon',
      payload: { token, couponId: items.id }
    })
  }

  const onHandlePreview = ({ items, type }) => {
    if (type === 'all') {
      navigation(`/dashboard/coupon/${items.id}/detail/all`, { state: items })
    } else {
      navigation(`/dashboard/coupon/${items.id}/detail`, { state: items })
    }
  }

  const onHandlePaginate = (page, pageSize) => {
    dispatch({
      type: 'coupon/get_coupon',
      payload: { token, params: { page: page } }
    })
  }

  const onFilterSelect = (productId) => {
    dispatch({
      type: 'coupon/get_coupon',
      payload: { token, params: { productId } }
    })
  }
  const onClearFilter = (page) => {
    dispatch({
      type: 'coupon/get_coupon',
      payload: { token, params: { page: page } }
    })
  }

  const downloadCsv = (couponId, type, name) => {
    const filename = `Report_${name}_${moment().format('DD-MM-YYYY')}.csv`
    dispatch({
      type: 'coupon/download_coupon',
      payload: {
        couponId,
        token,
        params: {
          type
        }
      }
    })
    setFileName(filename)
  }

  return (
    <DefaultLayout>
      {dataDownload && (
        <CSVLink
          data={dataDownload}
          filename={filename}
          ref={downloadCsvRef}
          target='_blank'
          style={{ display: 'none' }}
        />
      )}

      <Gap height='1rem' />
      <Layout className='container-roles'>
        <Content className='container'>
          <Header
            simple
            title='Create Coupon'
            type='primary'
            placeholder='search coupon by code coupon'
            icon={<PlusCircleOutlined />}
            onClick={onHandleCreateCampaign}
            onChange={({ target }) => setValue(target.value)}
            onClickSearch={onHandleSearch}
            filter
            data={dataMaster}
            onFilterSelect={onFilterSelect}
            onClearFilter={onClearFilter}
          />
          <Gap height='1rem' />
          <Table
            rowKey='id'
            loading={loading}
            columns={columns}
            dataSource={data ?? []}
            rowSelection={{
              type: 'checkbox'
            }}
            scroll={{ x: 'max-content' }}
            pagination={
              meta && {
                defaultPageSize: meta.itemsPerPage,
                total: meta.totalItems,
                pageSize: meta.itemsPerPage,
                onChange: (page, pageSize) => onHandlePaginate(page, pageSize)
              }
            }
          />
        </Content>
      </Layout>
    </DefaultLayout>
  )
}

const mapStateToProps = ({ reducerCoupons, reducerProductMaster }) => {
  return {
    ...reducerCoupons,
    dataMaster: reducerProductMaster.productMaster
  }
}

export const Coupon = connect(mapStateToProps)(_Coupon)

_Coupon.propTypes = {
  token: PropTypes.string,
  dispatch: PropTypes.func,
  data: PropTypes.array,
  dataMaster: PropTypes.array,
  dataDownload: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.array,
    PropTypes.string
  ]),
  loading: PropTypes.bool,
  meta: PropTypes.object
}
